import { ImageRepositoriesList } from "./image/ImageRepositoriesList";

/** The Action Images tab: the org's private image repositories. */
export function Images() {
  return <ImageRepositoriesList />;
}
